'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TextFormatting = require('@/helpers/TextFormatting');

var _MessageInfo = require('./MessageInfo');

var _MessageInfo2 = _interopRequireDefault(_MessageInfo);

var _MessageListAvatar = require('./MessageListAvatar');

var _MessageListAvatar2 = _interopRequireDefault(_MessageListAvatar);

var _AwayStatusIndicator = require('./AwayStatusIndicator');

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

var _TypingStatusIndicator = require('./TypingStatusIndicator');

var _TypingStatusIndicator2 = _interopRequireDefault(_TypingStatusIndicator);

var _MediaViewer = require('./MediaViewer');

var _MediaViewer2 = _interopRequireDefault(_MediaViewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        MessageAvatar: _MessageListAvatar2.default,
        MessageInfo: _MessageInfo2.default,
        AwayStatusIndicator: _AwayStatusIndicator2.default,
        TypingStatusIndicator: _TypingStatusIndicator2.default,
        MediaViewer: _MediaViewer2.default
    },
    props: ['ml', 'message', 'idx'],
    data: function data() {
        return {};
    },
    computed: {
        showRealName: function showRealName() {
            if (!this.ml.buffer.setting('show_realnames')) {
                return false;
            }

            var client = this.ml.buffer.getNetwork().ircClient;
            if (!client.network.cap.isEnabled('extended-join')) {
                return false;
            }

            if (!this.message.user || !this.message.user.realname) {
                return false;
            }

            if (this.message.user.nick.toLowerCase() === this.message.user.realname.toLowerCase()) {
                return false;
            }

            if (_TextFormatting.urlRegex.test(this.message.user.realname)) {
                return false;
            }

            return true;
        },
        userColour: function userColour() {
            return this.ml.userColour(this.message.user);
        }
    },
    methods: {
        getNetwork: function getNetwork() {
            return this.ml.buffer.getNetwork();
        },
        isRepeat: function isRepeat() {
            var ml = this.ml;
            var idx = this.idx;
            var message = this.message;
            var prevMessage = ml.filteredMessages[idx - 1];

            return !!prevMessage && prevMessage.nick === message.nick && message.time - prevMessage.time < 60000 && prevMessage.type !== 'traffic' && message.type !== 'traffic' && message.type === prevMessage.type;
        },
        isHoveringOverMessage: function isHoveringOverMessage(message) {
            return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
        },
        isMessage: function isMessage(message) {
            var types = ['privmsg', 'action', 'notice', 'message'];
            return types.indexOf(message.type) > -1;
        },
        displayAvatar: function displayAvatar(message) {
            if (!message.user) {
                return false;
            }

            if (this.ml.buffer.isServer() || this.ml.buffer.isSpecial()) {
                return false;
            }
            return true;
        },
        userMode: function userMode(user) {
            return this.ml.buffer.userMode(user);
        },
        userModePrefix: function userModePrefix(user) {
            return this.ml.buffer.userModePrefix(user);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListMessageModern"]
window._kiwi_exports.components.MessageListMessageModern = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MessageListMessageModern.vue
// module id = QAaf
// module chunks = 1